export default [
  {
    path: '/apps/workflow-usuario/list',
    name: 'apps-workflow-usuario-list',
    component: () => import('@/views/app/worflow/workflow-usuario/list/Index.vue'),
    meta: {
      pageTitle: 'WorkFlow X Usuários',
    },
  },
];
